<template>
    <BCard no-body>
      <BCardHeader class="pb-50">
        <h5> {{$t("Filters")}} </h5>
      </BCardHeader>
      <BCardBody>
        <BRow>
          <BCol cols="12" md="6" class="mb-md-0 mb-2" >
            <label>{{$t('Group')}}</label>
            <vSelect v-if="groups && groups.length>1" v-model="groupFilter" :options="groups" label="name" class="w-100" :reduce="val => val.id" />
          </BCol>
        </BRow>
      </BCardBody>
    </BCard>
  </template>

  <script>
  import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
  import { inject } from '@vue/composition-api';
  import vSelect from 'vue-select'

  export default {
    components: { BRow, BCol, BCard, BCardHeader, BCardBody, vSelect, },
    setup(){
        const groupFilter = inject('groupFilter')
        const groups = inject('groups')

        return {
            groupFilter,
            groups
        }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
